<template>
  <v-container fluid style="padding: 0; min-height: 100vh">
    <v-row no-gutters>
      <v-col cols="12">
        <GlobalNav></GlobalNav>
      </v-col>
      <v-col cols="12">
        <div class="d-flex h-100">
          <SideBar></SideBar>
          <div class="pa-5 w-100">
            <BreadCrumb :linksData="linksData" class="mb-5" />
            <div
              class="leads-managements-link d-flex align-center ga-2 my-3 py-3"
            >
              <div
                class="link cursor-pointer hoverd-style-line d-flex align-center ga-2"
              >
                <router-link
                  style="text-decoration: none"
                  to="/home-page"
                  class="d-flex align-center ga-2"
                >
                  <span>{{ $t("Engagement & insights") }}</span>
                </router-link>
              </div>
            </div>
            <div class="mt-5 mb-5"><Filter /></div>

            <v-dialog v-model="store.dialog" max-width="520" persistent>
              <v-card>
                <v-card-title class="text-h6">Select Your Page</v-card-title>
                <v-card-text>
                  <v-radio-group
                    v-model="store.selectedPageId"
                    name="pages"
                    color="primary"
                  >
                    <v-radio
                      v-for="p in pagesList"
                      :key="p.page_id"
                      class="w-full"
                      :value="String(p.page_id)"
                    >
                      <template #label>
                        <div class="d-flex align-center ga-3">
                          <img
                            :src="p.image"
                            alt=""
                            style="
                              width: 28px;
                              height: 28px;
                              border-radius: 50%;
                              object-fit: cover;
                            "
                            @error="(e) => (e.target.style.display = 'none')"
                          />
                          <div class="d-flex flex-column">
                            <span class="text-body-2 font-medium">{{
                              p.page_name
                            }}</span>
                            <span class="text-caption text-medium-emphasis">{{
                              p.category
                            }}</span>
                          </div>
                          <v-chip
                            v-if="p.status === 1"
                            size="x-small"
                            class="ml-auto"
                            color="green"
                            variant="tonal"
                          >
                            Active
                          </v-chip>
                        </div>
                      </template>
                    </v-radio>
                  </v-radio-group>
                  <div
                    v-if="!pagesList.length"
                    class="text-caption text-medium-emphasis"
                  >
                    No pages found.
                  </div>
                </v-card-text>

                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    variant="text"
                    color="primary"
                    @click="store.dialog = false"
                    >Cancel</v-btn
                  >
                  <v-btn
                    :disabled="!store.selectedPageId"
                    color="primary"
                    @click="onConnect"
                  >
                    <v-progress-circular
                      v-if="store.loading_page"
                      indeterminate
                      color="primary"
                      size="20"
                    />
                    Connect
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <div><Table :body="store?.body" /></div>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import BreadCrumb from "@/components/layout/BreadCrumb.vue";
import GlobalNav from "@/components/layout/GlobalNav.vue";
import SideBar from "@/components/layout/SideBar.vue";
import Filter from "@/components/EngagementInsights/Filter.vue";
import Table from "@/components/EngagementInsights/Table.vue";
import { EngagementAndInsightsStore } from "@/store/EngagementAndInsights/EngagementAndInsights";
import facebookIcon from "@/assets/soft-ware-img/facebook-post-select.svg";
import snapchatIcon from "@/assets/soft-ware-img/snapchat-logo-svgrepo-com.svg";
import xIcon from "@/assets/soft-ware-img/x-twitter-icons.svg";
import tiktokIcon from "@/assets/soft-ware-img/tikTopkcampaign.svg";
import {
  clearModuleCache,
  clearModuleSelection,
  getModuleSelection,
  setModuleSelection,
} from "@/core/moduleCache";

const CACHE_MODULE = "engagement-insights";
export default {
  name: "EngagementAndInsights",
  components: { BreadCrumb, GlobalNav, SideBar, Filter, Table },
  data() {
    return {
      linksData: [
        { name: "Home", link: "/home-page" },
        { name: "Engagement & insights", link: "/" },
      ],
      store: EngagementAndInsightsStore(),
      facebookIcon,
      snapchatIcon,
      xIcon,
      tiktokIcon,
    };
  },
  computed: {
    pagesList() {
      const src = this.store?.pages;
      if (Array.isArray(src)) return src;
      try {
        const p = JSON.parse(src);
        return Array.isArray(p) ? p : [];
      } catch {
        return [];
      }
    },
  },
  watch: {
    pagesList: {
      immediate: true,
      handler(list) {
        if (!this.store.selectedPageId && list.length) {
          const active = list.find((p) => p.status === 1);
          this.store.selectedPageId = active
            ? String(active.page_id)
            : String(list[0].page_id);
        }
      },
    },
  },
  methods: {
    async onConnect() {
      this.store.loading_page = true;
      const previousPageId = getModuleSelection(CACHE_MODULE, null)?.pageId;
      if (String(previousPageId || "") !== String(this.store.selectedPageId)) {
        clearModuleCache(CACHE_MODULE);
      }
      setModuleSelection(CACHE_MODULE, {
        pageId: String(this.store.selectedPageId),
      });
      await this.store.getAllData(this.store.selectedPageId);
      this.store.dialog = false;
      this.store.loading_page = false;
    },
  },
  async mounted() {
    const savedPageId = getModuleSelection(CACHE_MODULE, null)?.pageId;
    const pagesLoaded = await this.store.getAllPage();
    const savedPageExists = this.pagesList.some(
      (page) => String(page.page_id) === String(savedPageId)
    );

    if (savedPageId && (!pagesLoaded || savedPageExists)) {
      this.store.selectedPageId = String(savedPageId);
      this.store.dialog = false;
      await this.store.getAllData(this.store.selectedPageId);
      return;
    }

    if (savedPageId) {
      clearModuleSelection(CACHE_MODULE);
      clearModuleCache(CACHE_MODULE);
    }
    this.store.dialog = true;
  },
};
</script>
